var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAdminUI)?_c('AdminFooter'):_c('SiteFooter')}
var staticRenderFns = []

export { render, staticRenderFns }